import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/order_settlements',
  component: Management,
  redirect: '/order_settlements/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/order_settlements/List'),
      meta: {
        auth: Auth.listOrderSettlements,
        activeMenu: '/ev_charging_station_settlements'
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/order_settlements/DetailLayout'),
      meta: {
        auth: Auth.showOrderSettlement,
        activeMenu: '/ev_charging_station_settlements'
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/order_settlements/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showOrderSettlement,
            activeMenu: '/ev_charging_station_settlements'
          }
        }
      ]
    }
  ]
}
